<!--
	描述：设置定时遥控所需的弹窗，支持日周月年
-->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			{{title}}
		</template>
		<div class="custom-scrollbar timeBody">
			<p>请选择周期:</p>
			<label><input type="radio" name="type" value="SINGLE" v-model="result.type"> 单次 </label>
			<label><input type="radio" name="type" value="DAY" v-model="result.type"> 日 </label>
			<label><input type="radio" name="type" value="WEEK" v-model="result.type"> 周 </label>
			<label><input type="radio" name="type" value="MONTH" v-model="result.type"> 月 </label>
			<label><input type="radio" name="type" value="YEAR" v-model="result.type"> 年 </label>
			<template v-if="result.type == 'SINGLE'">
				<p>请选择年:</p>
				<input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
				 v-model="result.year" min="1" />
			</template>
			<template v-if="result.type == 'YEAR' || result.type == 'SINGLE'">
				<p>请选择月份:</p>
				<input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
				 v-model="result.month" min="1" max="12" />
			</template>
			<template v-if="result.type != 'WEEK' && result.type != 'DAY'">
				<p>请选择日期(每月几号执行，如果不存在该日期则会跳过):</p>
				<input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
				 v-model="result.day" min="1" max="31" />
			</template>
			<template v-if="result.type == 'WEEK'">
				<p>请选择:</p>
				<label><input type="radio" name="week" value="1" v-model="result.week"> 周一 </label>
				<label><input type="radio" name="week" value="2" v-model="result.week"> 周二 </label>
				<label><input type="radio" name="week" value="3" v-model="result.week"> 周三 </label>
				<label><input type="radio" name="week" value="4" v-model="result.week"> 周四 </label>
				<label><input type="radio" name="week" value="5" v-model="result.week"> 周五 </label>
				<label><input type="radio" name="week" value="6" v-model="result.week"> 周六 </label>
				<label><input type="radio" name="week" value="7" v-model="result.week"> 周日 </label>
			</template>

			<p>请选择时间:</p>
			<input type="number" min="0" max="23" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
			 v-model="timeList[0]">
			<span> : </span>
			<input type="number" min="0" max="59" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
			 v-model="timeList[1]">
			<span> : </span>
			<input type="number" min="0" max="59" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
			 v-model="timeList[2]">
			<p>请选择操作:</p>
			<label><input type="radio" name="command" value="A1" v-model="result.command"> 合闸 </label>
			<label><input type="radio" name="command" value="A2" v-model="result.command"> 分闸 </label>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: [],
		data() {
			return {
				title: '',
				callback: undefined,
				cancelCallBack: undefined,
				result: {},
				timeList: []
			}
		},
		computed: {},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
			//debugger;
				if (this.callback != undefined) {
					this.result.time = this.timeList.join(":")
					if (this.callback(this.result) == false) {
						return
					}
				}
				this.close()
			},
			cancel() {
				if (this.cancelCallBack != undefined) {
					this.cancelCallBack()
				}
				this.close()
			},
			open(title, data, callback, cancelcallback) {
				this.title = title
				var now = new Date()
				if (data == undefined) {
					this.result = {
						type: 'SINGLE',
						year: now.getFullYear(),
						week: 1,
						month: now.getMonth() + 1,
						day: now.getDate(),
						time: now.formatByTime().split(" ")[1],
						command: "A1"
					}
				} else {
					let command=''
					if(data.command=="open"){
						command='A1'
					}else if(data.command=="close"){
						command='A2'
					}else{
						command=data.command.substring(0, 2)
					}
					this.result = data.tagObject
					this.result.command = command
					this.result.type = data.type
					this.result.pkid = data.pkid
					console.log(this.result.command )
				}
				this.timeList = this.result.time.split(":")
				this.callback = callback
				this.cancelCallBack = cancelcallback
				this.$refs.body.open()
			},
			close() {
				this.$refs.body.hide()
			},
		}
	}
</script>
<style scoped>
	.timeBody {
		height: 392px;
	}

	.timeBody p,
	.timeBody label,
	.timeBody input {
		cursor: pointer;
		margin: 5px 10px;
	}
</style>
